import { useState } from "react";
import { TimePickerIcon } from "pages/analytics/icons";
import { CustomDatePicker } from "pages/analytics/components";
import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";
import { Spin } from "antd";

export const UserCountSingleCard = ({ userItem }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={styles.cardContainer}>
      <div className={styles.topSection}>
        <div className={styles.header}>
          <div className={styles.label}>{userItem.header.label}</div>
          <div className={styles.iconContainer}>
            {userItem?.header?.icons?.map((Icon) => (
              <div className={styles.whiteCircle}>
                <Icon height={15} width={15} />
              </div>
            ))}
          </div>
        </div>
        <div className={styles.value}>{userItem.header.value}</div>
      </div>
      <div className={styles.separater}></div>
      <div className={styles.paidAndFree}>
        {userItem.paidAndFree?.map((item) => (
          <div
            className={
              styles[item.type === "paid" ? "paidSection" : "freeSection"]
            }
          >
            <div className={styles.smallLabel}>{item.label}</div>
            <div className={styles.smallValue} style={{ color: item.color }}>
              <div>{item.value}</div>
              <div>{item.percentage}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
